import React, { useMemo } from 'react'

import { SanityTabsCarouselTab } from '../../../graphql/gatsby'
import { imageUrlFor } from '../../../lib/sanity'
import { cn } from '../../utils/cn'

import chevronDown from '../../../img/icons/chevron-down.svg'
import imagePlaceholder from '../../../img/product-image-placeholder.png'

export interface TabsCarouselTabProps {
  tab: SanityTabsCarouselTab
  isActive: boolean
  selectTab: (tab: SanityTabsCarouselTab) => void
}

export const TabsCarouselTab: React.FC<TabsCarouselTabProps> = ({ tab, isActive, selectTab }) => {
  const imageUrl = useMemo(
    () =>
      imageUrlFor(tab.image || '')
        .width(130)
        .height(130)
        .dpr(2)
        .fit('max')
        .auto('format')
        .url() || imagePlaceholder,
    [tab.image],
  )
  return (
    <button
      key={tab.title}
      onClick={() => selectTab(tab)}
      className={cn(
        'w-full',
        'md:flex-shrink-0 md:w-[311px] lg:w-[336px] xl:w-[400px]',
        'pb-5 border-b-4 border-transparent',
        !isActive && 'border-brand-orange',
        '!flex flex-row',
      )}
    >
      <img src={imageUrl} alt={tab.title || ''} className="flex flex-1" />
      <div className="flex flex-[2] flex-col text-left justify-between pl-3 md:pl-5">
        <p className="text-[9px] mt-1 md:text-[12px] xl:text-sm uppercase font-light">
          {tab.label}
        </p>
        <div className="flex flex-row justify-between items-end">
          <p className="font-medium text-base md:text-xl xl:text-2xl text-text-primary">
            {tab.title}
          </p>
          <img
            src={chevronDown}
            alt={isActive ? 'Close' : 'Open'}
            className={cn('w-[33px]', isActive && 'rotate-180')}
          />
        </div>
      </div>
    </button>
  )
}
